import React from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import type { IGatsbyImageData } from "gatsby-plugin-image";
/* @ts-ignore */
import { ProductsJsonFields} from '../gatsby-types';


type GatsbyImageWrapperProps = {
    className?: string;
    imageIndex?: number;
    imgStyle?: React.CSSProperties;
    fields?: ProductsJsonFields;
    altComponent?: React.ReactNode;
    propertyToGet?: "images" | "thumbnail";
};

export default function GatsbyImageWrapper({
    className = "",
    imageIndex = 0,
    imgStyle,
    fields,
    altComponent,
    propertyToGet = "images",
}: GatsbyImageWrapperProps) {
    let gatsbyImageData: IGatsbyImageData | undefined;

    if (fields?.[propertyToGet]?.[imageIndex]?.childImageSharp?.gatsbyImageData) {
        gatsbyImageData = fields[propertyToGet][imageIndex].childImageSharp?.gatsbyImageData;
    }

    return (
        <>
            {gatsbyImageData ? (
                <GatsbyImage
                    className={className}
                    image={gatsbyImageData}
                    imgStyle={imgStyle}
                    alt=""
                />
            ) : fields?.imageUrls?.[imageIndex] ? (
                <img
                    className={`gatsby-image-wrapper ${className}`}
                    src={fields.imageUrls[imageIndex] as string}
                    style={imgStyle}
                    alt=""
                />
            ) : (
                altComponent ?? (
                    <StaticImage
                        className={className}
                        src="../images/product-image-placeholder.jpg"
                        alt=""
                        imgStyle={{ objectFit: "contain" }}
                    />
                )
            )}
        </>
    );
}
